// Libs
import React from 'react';

// Components
import Button from '../../../../Button';

const SaveForLaterButton = ({ product, count, saveForLater, className }) => (
  <Button
    data-testid="save-for-later-btn"
    className={className}
    variant="text"
    onClick={() => saveForLater(product, count)}>
    Save For Later
  </Button>
);

export default SaveForLaterButton;
